import React, { useState } from 'react';

const WelcomeScreen = ({ onContinue }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onContinue(email);
  };

  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-[2px] flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-lg w-full mx-4">
        <div className="text-center mb-8">
          <img 
            src="/images/ppal-dorado.png" 
            alt="Nee'k Logo" 
            className="mx-auto mb-6 h-16 w-auto"
          />
          <h2 className="text-3xl font-bold text-dark-blue mb-2">
            ¡Bienvenido a Nee'k!
          </h2>
          <p className="text-gray-600 text-lg">
            Calcula el rendimiento de tu inversión y descubre las oportunidades que tenemos para ti
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
              Correo Electrónico
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              required
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-gold focus:border-transparent transition-all"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-dark-blue hover:bg-opacity-90 text-white font-medium py-3 px-6 rounded-lg transition-all transform hover:scale-[1.02] active:scale-[0.98]"
          >
            Continuar
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-500">
          Al continuar, aceptas recibir información sobre nuestros productos y servicios
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen; 